import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import { PAGE_BG, TEXT_SECONDARY } from "../utils/colors";
import { FS_BODY } from "../utils/typography";

// Loading screen: brand spinner + message, on a transparent canvas so it
// blends into the Zoho page behind the iframe (spec §5).
//
// Deliberately has NO logo — spec §5 forbids a logo image anywhere in the app.
// `fullScreen` for whole routes, inline for a tab loading inside the page.
const PageLoader = ({ fullScreen = false, message = "Loading…" }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      bgcolor: PAGE_BG,
      ...(fullScreen
        ? { position: "fixed", inset: 0, zIndex: 1500 }
        : { py: 8 }),
    }}
  >
    <CircularProgress size={fullScreen ? 34 : 26} thickness={4.5} color="primary" />
    <Typography sx={{ color: TEXT_SECONDARY, fontSize: FS_BODY }}>
      {message}
    </Typography>
  </Box>
);

export default PageLoader;
